import { render, staticRenderFns } from "./TaskChatRoom.vue?vue&type=template&id=31727af8&scoped=true&lang=html&"
import script from "./TaskChatRoom.vue?vue&type=script&lang=js&"
export * from "./TaskChatRoom.vue?vue&type=script&lang=js&"
import style0 from "./TaskChatRoom.vue?vue&type=style&index=0&id=31727af8&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31727af8",
  null
  
)

export default component.exports